var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Registration Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.81,32,47,30.17a1.2,1.2,0,0,0-1.67,0l-7.71,7.71a.46.46,0,0,0-.13.27L37,41.43a.46.46,0,0,0,.14.4.47.47,0,0,0,.33.14h.07l3.28-.45a.46.46,0,0,0,.27-.13l7.71-7.71a1.17,1.17,0,0,0,.34-.83A1.2,1.2,0,0,0,48.81,32ZM38,41m8-5.81"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.62,
    y1: 31.85,
    x2: 47.1,
    y2: 35.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.5,36.33a13,13,0,0,0,13,13H43v3.22a2.28,2.28,0,0,1-2.29,2.29H11.29A2.28,2.28,0,0,1,9,52.54V11.12a2.28,2.28,0,0,1,2.29-2.29H40.71A2.28,2.28,0,0,1,43,11.12V23.34h-.5A13,13,0,0,0,29.5,36.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.5,36.33a13,13,0,0,1-12.5,13h-.5a13,13,0,0,1,0-26H43A13,13,0,0,1,55.5,36.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.5,
    y1: 15.33,
    x2: 35.5,
    y2: 15.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.5,
    y1: 21.33,
    x2: 31.5,
    y2: 21.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.5,
    y1: 28.33,
    x2: 24.5,
    y2: 28.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.5,
    y1: 35.33,
    x2: 23.5,
    y2: 35.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.5,
    y1: 42.33,
    x2: 24.5,
    y2: 42.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.5,
    y1: 49.33,
    x2: 28.5,
    y2: 49.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationSettings01);
export default __webpack_public_path__ + "static/media/Registration_Settings_01.ede4c8642a3377a7684d257590a7584a.svg";
export { ForwardRef as ReactComponent };